<section class="centered-with-padding pb-1 pt-4">
  <div class="relative">
    <div
      #slidesElementRef
      class="no-scrollbar grid h-[307px] snap-x snap-mandatory auto-cols-[100%] grid-flow-col gap-3 overflow-x-scroll scroll-smooth desk:h-auto desk:auto-cols-auto desk:grid-flow-row desk:grid-cols-6">
      @for (image of data.images; track i; let i = $index) {
        <div
          [class]="i < 2 ? 'desk:col-span-3' : 'desk:col-span-2'"
          class="snap-start overflow-hidden rounded-3xl desk:aspect-square">
          <app-image
            [image]="image"
            [isPriority]="!isImageInPreviousBlocks && $index < 2"
            [pregenerationSize]="{ width: 534, height: 534 }" />
        </div>
      }
    </div>
    <button class="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 desk:hidden">
      <div
        (click)="moveSlider('prev')"
        class="drop-shadow-custom flex size-8 items-center justify-center rounded-lg bg-white">
        <app-svg [width]="24" class="block rotate-180" src="assets/icons/arrow-right.svg" />
      </div>
    </button>
    <button class="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 desk:hidden">
      <div
        (click)="moveSlider('next')"
        class="drop-shadow-custom flex size-8 items-center justify-center rounded-lg bg-white">
        <app-svg [width]="24" src="assets/icons/arrow-right.svg" />
      </div>
    </button>
  </div>
</section>
